export const useCharacters = () => {
  const allowCharactersBackup = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "ArrowLeft", "ArrowRight", "Backspace", "Delete"]

  const allowCharacters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "ArrowLeft", "ArrowRight", "Backspace", "Delete"]

  /**
   *
   * @param event
   * @param arr
   */
  function checkField(event, arr) {
    let found = false

    for (let i = 0; i < arr.length; i++) {
      if ((event.keyCode >= 65 && event.keyCode <= 90 && arr[i] === event.key.toUpperCase()) || (arr[i] === event.key)) {
        found = true
        break
      }
    }

    // ctrlKey für windows, metakey für macos, (metakey ist unter windows die windowstaste)
    // c, v, x kopieren, einsetzen, ausschneiden
    if (((event.ctrlKey || event.metaKey) && event.keyCode === 67) || ((event.ctrlKey || event.metaKey) && event.keyCode === 86) || ((event.ctrlKey || event.metaKey) && event.keyCode === 88)) {
      found = true
    }

    // Wichtig damit man per ENTER einen submit auslösen kann, also das Formular mit ENTER abschicken kann
    if (event.keyCode === 13) {
      found = true
    }

    // if (event.key === 'Dead') {
    //   input.blur()
    //   setTimeout(() => input.focus())
    // }

    if (!found) {
      event.preventDefault()
      event.stopPropagation()

      // model.value.code.replace(/\W/g, '')
      // model.value.code.replace(/\[^A-Z0-9]/g, '')
    }
  }

  return {
    allowCharactersBackup, allowCharacters, checkField
  }
}

